const UPLOAD = '/upload';

export const ROUTE_HOME_UPLOAD = UPLOAD + '/home';
export const uploadWebRoutes = [ROUTE_HOME_UPLOAD];
